// REGISTER
export const SALES_REGISTER = "/seller/register";
export const INVEST_REGISTER = "/oauth/register";

//LOGIN
export const POST_LOGIN = "/OAuth/Token";
export const POST_DECODE_ENCRYPT_LOGIN = "/OAuth/DecodeEncryptUserToken";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

// FORGOT PASSWORD
export const FORGOT_PASSWORD = "/Public/SendChangePasswordEmail";
export const FORGOT_PASSWORD_NEW_PASS = "/Public/ChangePasswordViaLink";

// USER DATA
export const GET_AUTH_DATA = "/Common/GetAuthenticationData";

// PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Task
export const GET_TASK_LIST = "/apps/task";
export const ADD_NEW_TASK = "/apps/task";
export const UPDATE_TASK = "/apps/task";
export const DELETE_TASK = "/apps/task";

// kanban
export const GET_TASKS = "/apps/tasks";
export const ADD_TASKS = "/add/tasks";
export const UPDATE_TASKS = "/update/tasks";
export const DELETE_TASKS = "/delete/tasks";

// To do
export const GET_TODOS = "/todo";
export const DELETE_TODO = "/delete/todo";
export const ADD_NEW_TODO = "/add/todo";
export const UPDATE_TODO = "/update/todo";

//JOB APPLICATION
export const GET_API_KEY = "/api-key";

// GENERAL USAGE PARTNER QUERY
export const PARTNER_QUERY = "/Partner/";

// GENERAL USAGE SELLER QUERY
export const SELLER_QUERY = "/Seller/";

// GET COUNTRY LIST
export const GET_COUNTRY_LIST = "/Common/GetCountryList";
export const GET_COUNTRY_LIST_INT2 = "Common/GetCountryListInt2";

// GET SUMMARY CARDS INFO
export const GET_SUMMARY_CARD_INFO = "/SummaryCards";

// GET REFERRAL LINK DETAIL
export const GET_REFERAL_LINK_INFO = "/ReferralLinkDetails";

// GET CONTRACTS TO PARTNER
export const GET_CONTRACTS_TO_PARTNER = "/contractsToPartner";

// ADD REFERRAL LINK DETAILS
export const ADD_REFERRAL_LINK_DETAILS = "/ReferralLinkDetailsForLanguage";

// GET REBATE DETAIL
export const GET_REBATE_DETAILS = "/RebateDetails";

// DASHBOARD GRAPHİC PARTNER CLIENTS
export const GET_PARTNER_CLIENTS_GRAPHIC_INFO = "/partner-clients";

// DASHBOARD GRAPHİC PARTNER TRADING VOLUME
export const GET_PARTNER_TRADING_VOLUME_GRAPHIC_INFO =
  "/partnerChartTradingVolume";

// DASHBOARD GRAPHİC PARTNER BALANCE
export const GET_PARTNER_BALANCE_GRAPHIC_INFO = "/partnerChartBalance";

// GET INSTRUMENT LIST
export const GET_INSTRUMENT_GROUPS = "/Common/GetAllInstrumentGroups";

// GET DOCUMENT TYPE LIST
export const GET_DOCUMENT_TYPE_LIST = "Common/GetDocumentTypeList";

// IB ONBOARDING PERSONAL INFO
export const IB_ONBOARDING_PERSONAL_INFO = "/Partner/PersonalInformation";

// INVEST IB ONBOARDING SMS REQUEST
export const INVEST_IB_ONBOARDING_SMS_REQ = "partner/SendPhoneVerificationOtp";

// INVEST IB ONBOARDING CODE SEND
export const INVEST_IB_ONBOARDING_CODE_SEND = "/VerifyPartnerPhoneNumber";

// IB ONBOARDING BANK INFO
export const IB_ONBOARDING_BANK_INFO = "/BankInformation";

// IB ONBOARDING IDENTITY VERIFICATION
export const IB_ONBOARDING_IDENTITY_VERIFICATION = "/IdentityVerification";

// IB ONBOARDING ADDRESS VERIFICATION
export const IB_ONBOARDING_ADDRESS_VERIFICATION = "/AddressVerification";

// UPDATE PERSONAL PASSWORD
export const CHANGE_PERSONAL_PASSWORD = "/Membership/ChangePassword/Sync";

// PNL SHARE CONTRACT INFO
export const PNL_SHARE_CONTRACT_INFO =
  "contracts/GetContractPnlShareInformations/partner/";

// GET USER ADDRESS INFOS
export const GET_USER_ADDRESS_INFOS =
  "Partner/GetScaPartnerAddressInformations";

// GET USER DATEOF BIRTH INFO
export const GET_USER_DATE_OF_BIRTH_INFO = "/GetScaClients";

// REPORTS URLS
export const GET_REPORTS_OPEN_POSITIONS = "/GetPagedPartnerOpenPositions";
export const GET_MONEY_TRANSFERS = "/GetPagedPartnerMoneyTransfers";
export const GET_TOP_CLIENTS = "/GetPagedPartnerTopClients";
export const GET_PARTNER_CLIENTS = "/GetPagedPartnerClients";
export const GET_CLOSED_POSITIONS = "/GetPagedPartnerDeals";
export const GET_DEALS = "/GetPagedPartnerAllDeals";
export const GET_EQUITY_REPORTS = "/GetPagedPartnerBalanceReports";
export const GET_SUB_IBS = "/GetPagedPartnerSubPartners";

// CONTRACTS
export const GET_PAGED_CONTRACTS = "/GetPagedContracts";

// ADD OWN CONTRACTS
export const ADD_OWN_CONTRACTS = "/Contract/AddOwnContract/";

// GET OWN CONTRACT REVIEW
export const GET_OWN_CONTRACT_REVIEW = "/Contract/GetOwnContractReview/";

// CONTRACTS DETAIL
export const GET_PAGED_CONTRACT_ACCOUNT = "/Partner/GetPagedContractAccounts";

// CONTRACTS RATES DETAIL
export const GET_STANDART_RATES = "Contract/GetWithStandardRateInfos/";

// CONTRACTS RATES DETAIL
export const GET_OLD_CONTRACT_RATES = "Contract/GetContractAndRatesDetails/";

// WITHDRAWAL/INTERNAL TRANSFER GET / POST
export const GET_SCA_ACCOUNT_INFO_LIST = "Common/ScaAccountInfoList";
export const GET_WALLET_ACCOUNT_INFO_LIST = "Common/WalletAccountInfoList/";
export const ADD_WITHDRAWAL_INFO = "partner/WithdrawalRequest";
export const ADD_WITHDRAWAL_WALLET_INFO = "partner/WalletRequest";
export const ADD_INTERNAL_TRANSFER_INFO = "partner/InternalTransferRequest";

// GET DEPOSIT REDIRECT PARAMETER
export const GET_DEPOSIT_REDIRECT_PARAMETER = "Common/TokenDeposit";

//REBATES
export const GET_REBATES = "/GetPagedStandardRebateReport";
export const GET_REBATES_PNL = "/GetPagedPnlShareRebate";

// PAYMENT HISTORY
export const GET_PAGED_PAYMENT_HISTORY_REPORT = "/GetPagedPaymentHistoryReport";

// GET OFFICES INFO
export const GET_OFFICES_INFO = "/Common/offices";

// GET TRANSLATION
export const GET_TRANSLATION = "partner/Translation/Keys/";

//! SALES
// GET SALES SUMMARY CARDS INFO
export const GET_SALES_SUMMARY_CARD_INFO = "/seller/dashboard/summarycard/";

// DASHBOARD GRAPHIC SALES NETWORK DATA
export const GET_SALES_NETWORK_GRAPHIC_INFO = "/seller/getsellernetworkchart/";

// GET SALES REFERRAL LINK DETAILS INFO
export const GET_SALES_REFERRAL_LINK_DETAILS_INFO =
  "/seller/sellerReferralLinkDetails/";

// ADD SALES REFERRAL LINK DETAILS
export const ADD_SALES_REFERRAL_LINK_DETAILS =
  "/seller/sellerreferrallinkdetailsforlanguage/";

// GET SALES REBATE DETAIL
export const GET_SALES_REBATE_DETAILS = "/BalanceDetails";

// SALES REPORTS URLS
export const GET_SALES_REPORTS_PARTNER_LIST =
  "/seller/getpagedsellersubpartners/";
export const GET_SALES_REPORTS_CLIENT_LIST = "/seller/getpagedsellerretail/";
export const GET_SALES_REPORTS_NETWORK_LIST = "/seller/getpagedsellernetwork/";
export const GET_SALES_REPORTS_MONEY_TRANSFER_LIST =
  "/seller/getpagedsellermoneytransferreport/";
export const GET_SALES_REPORTS_EQUITY = "seller/getpagedsellerequityreport/";

// SALES CONTRACTS DETAIL
export const GET_SALES_PAGED_CONTRACT_ACCOUNT_DETAIL =
  "/Seller/GetPagedSellerContractAccounts";

// SALES REBATE / COMMISSION DETAIL
export const GET_SALES_PAGED_COMMISSINON_DETAIL = "/GetPagedCommisionReport";

// SALES PAYMENT/TRANSACTION HISTORY
export const GET_SALES_PAGED_PAYMENT_HISTORY_REPORT =
  "/seller/getpagedsellertransactionreport/";
